import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/procurement/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    redirect: MODULE_PATH + 'management',
    name: 'Procurement',
    meta: {
      title: 'Common.menu.procurement_management',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.procurements,
      icon: 'local_shipping',
      handicap: true,
    },
    children: [
      {
        path: MODULE_PATH + 'management',
        component: load('application/procurement/components/ProcurementManagement'),
        name: 'Procurement Management',
        meta: {
          title: 'Common.menu.procurement_management',
          icon: 'attach_money',
          menuItem: true,
          sorting: 801,
        },
      },
    ],
  },
]
